import React from "react";
import { useParams } from "react-router-dom";
import useFetch from "../../hooks/useFetch";
import { useState } from "react";
import { apiPath } from "../../utility/Constant";
import { useEffect } from "react";
import GlobalForm from "../../components/globalForm/GlobalForm";
import { updateData } from "../../hooks/update";

function CsrHighlightAddpage() {
  const { CSRApi } = apiPath;

  const data = [
    {
      elementType: "textField",
      label: "Highlight Count",
      type: "text",
      name: "highlightTitle",
    },
    {
      elementType: "textField",
      label: "Highlight Description",
      type: "text",
      name: "highlightDescription",
    },
  ];

  const update = (data) => {
    data.slug = "highlight";
    updateData(`${CSRApi}`, data, null, null, null, true);
  };

  return (
    <div>
      <GlobalForm data={data} update={update} />
    </div>
  );
}

export default CsrHighlightAddpage;
